import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=dd5426d6&scoped=true&lang=pug"
import script from "./Prices.vue?vue&type=script&lang=js"
export * from "./Prices.vue?vue&type=script&lang=js"
import style0 from "./Prices.vue?vue&type=style&index=0&id=dd5426d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5426d6",
  null
  
)

export default component.exports